import { render, staticRenderFns } from "./certDetail.vue?vue&type=template&id=64c5d7f1&scoped=true&"
import script from "./certDetail.vue?vue&type=script&lang=js&"
export * from "./certDetail.vue?vue&type=script&lang=js&"
import style0 from "./certDetail.vue?vue&type=style&index=0&id=64c5d7f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c5d7f1",
  null
  
)

export default component.exports